import ErrorMessages from '@/utils/ErrorMessages'
import Store from '@/store'

export default function useHelpers() {

    const photoDefault = '@/assets/images/no_user.jpeg'

    const formatImage = (image) => {
        return image ? (
            image.indexOf('http') >= 0 ? image : 'https://www.chatmix.com.br/storage/' + image
        ) : photoDefault
    }
    const photoUserDefault = (e) => {
        return e.target.src = photoDefault
    }

    const statusAttendance = (attendance = null) => {
        let status = [
            { title: 'Encerrado', name: 'closed' },
            { title: 'Andamento', name: 'progress' },
            { title: 'Espera', name: 'wait' },
            { title: 'Automação', name: 'automation' },
        ]
        if (attendance) {
            if (attendance['closed_at']) {
                return status[0]
            } else if (attendance['user_id']) {
                return status[1]
            } else if (attendance['transfered_to']) {
                return status[2]
            } else {
                return status[3]
            }
        } else {
            return status
        }
    }

    const formatDateTimeDMY = (dateTime) => {
        if (!dateTime) return ''
        let d
        if (dateTime.indexOf('T') != -1) {
            d = dateTime.split('T')
        } else {
            d = dateTime.split(' ')
        }
        // FORMATA A DATA
        let dateT = d[0]
        dateT = dateT.split('-')
        dateT = dateT[2] + '/' + dateT[1] + '/' + dateT[0]
        // retorna data e hora
        return dateT + ' ' + d[1].substring(0, 8)
    }

    const getError = (error) => {
        let errorCode = error ? error : (error?.response?.data?.error || 'ServerError')
        if (!ErrorMessages[errorCode]?.title) {
            errorCode = 'ServerError'
        }
        return {
            title: ErrorMessages[errorCode].title,
            content: ErrorMessages[errorCode].text,
            text: ErrorMessages[errorCode].text,
            code: errorCode,
            type: 'error',
        }

    }

    const errorRequest = (response) => {
        const objeto = JSON.parse(response.request.response)
        const errorCode =   objeto.error
        return {
            code: errorCode,
            type: 'error',
            status: response.request.status,
            error: errorCode,
            title: ErrorMessages[errorCode].title,
            message: ErrorMessages[errorCode].text,
            teste: response.request.response,
            reponseText: response.request.responseText,
        }
    }

    const oldUrl = (path) => defineUrl(path)

    /**
     * @param {string|undefined} path
     * @returns {string}
     */
    const defineUrl = (path) => {
        if (path === undefined) return window.origin

        if (path[0] === '/') {
            path = path.substring(1)
        }

        return `${window.origin}/${path}`
    }

    const checkPermission = (permission, permissions) => {
        if (!permission) return true
        
        // Retrieve data to user
        const userData = permissions || Store.state?.user?.user?.level
        
        // Execute validation to check access module
        return permission <= userData
    }

    return {
        formatImage,
        photoUserDefault,
        statusAttendance,
        formatDateTimeDMY,
        getError,
        errorRequest,
        oldUrl,
        defineUrl,
        checkPermission,
    }
}
